import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { showLiveIndicator } from '@services';
import { GlobalContext } from '../GlobalContext';
import LiveIndicator from '../LiveIndicator';

function VideoCard({ video }: any) {
  const globalContext = React.useContext(GlobalContext);
  return (
    <div className="flex group flex-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 mb-12 px-2.5">
      <Link className="relative" to={video.slug}>
        {video.thumbnailMediaStandard
                && (
                <GatsbyImage
                  image={getImage(video.thumbnailMediaStandard.gatsbyImageData)!}
                  alt={video.title}
                  objectPosition="center"
                  style={{ width: '100%' }}
                />
                )}
        {showLiveIndicator(globalContext?.liveItems, video) && <LiveIndicator />}
      </Link>
      <Link className="pt-2 text-white text-[20px] group-hover:text-chdGreen-light" to={video.slug}>{video.title}</Link>
    </div>
  );
}

export default VideoCard;
